import { render } from "./QuickActionIcon.vue?vue&type=template&id=43246b85"
import script from "./QuickActionIcon.vue?vue&type=script&lang=js"
export * from "./QuickActionIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__